export const AgendaScenarioId = 'MonthAgenda';
